import PropTypes from 'prop-types';
import React from 'react';
import FeedbackScreenTitle from '../common/feedback-screen-title';
import FeedbackSubmitButton from '../common/feedback-submit-button';
import RatingInput from './rating-input';

const FeedbackRatingScreen = ({
  rating, ratingStyle, score, isSubmitting, onScoreChange, onSubmit,
}) => (
  <div className="px-5 py-6 flex flex-col gap-6">
    <FeedbackScreenTitle title={rating.heading} subtitle={rating.question} />
    <div className="flex justify-center">
      <RatingInput ratingStyle={ratingStyle} value={score} onChange={onScoreChange} />
    </div>
    <FeedbackSubmitButton
      label={rating.buttonText}
      disabled={score === null}
      loading={isSubmitting}
      onClick={onSubmit}
    />
  </div>
);

FeedbackRatingScreen.propTypes = {
  rating: PropTypes.shape({
    heading: PropTypes.string,
    question: PropTypes.string,
    buttonText: PropTypes.string,
  }).isRequired,
  ratingStyle: PropTypes.string,
  score: PropTypes.number,
  isSubmitting: PropTypes.bool,
  onScoreChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

FeedbackRatingScreen.defaultProps = {
  ratingStyle: undefined,
  score: null,
  isSubmitting: false,
};

export default FeedbackRatingScreen;
